import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {ActiveCartFacade, Cart, OrderEntry, PromotionLocation, SelectiveCartFacade} from '@spartacus/cart/base/root';
import {combineLatest, Observable, of} from 'rxjs';
import {GonvarriCart} from "../../core/models/gonvarri-cart.model";
import {filter, map, tap} from "rxjs/operators";
import {AuthService, RoutingService} from "@spartacus/core";
import {CartConfigService} from "@spartacus/cart/base/core";

@Component({
    selector: 'app-gonvarri-cart-totals',
    templateUrl: './gonvarri-cart-totals.component.html',
    styleUrl: './gonvarri-cart-totals.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GonvarriCartTotalsComponent implements OnInit {

  cart$: Observable<GonvarriCart> = of();
  entries$: Observable<any[]> = new Observable<OrderEntry[]>();

  constructor(
    protected activeCartService: ActiveCartFacade
  ) {}

  ngOnInit() {
    this.cart$ = this.activeCartService.getActive() as any;
    this.entries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => entries.length > 0));
  }
}
